// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgAppLogoShort = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={36} height={32} viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_1434_4127)">
      <g clipPath="url(#clip1_1434_4127)" fill="#4038FF">
        <path d="M2.999 32H0l4.166-16.662a8.723 8.723 0 0 1 4.4-5.606L2.999 32ZM8.246 32H5.248l5.6-22.403a6.91 6.91 0 0 1 4.188-4.76L8.246 32ZM13.493 32h-2.998L17.38 4.453a5.879 5.879 0 0 1 11.407 0L35.636 32h-2.96l-6.71-26.841a2.97 2.97 0 0 0-5.762 0L13.494 32Z" />
        <path d="M25.18 32h-2.998l-3.22-12.88 1.5-5.997L25.18 32ZM30.427 32H27.43L21.586 8.625l.734-2.937a.788.788 0 0 1 1.53 0L30.426 32Z" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1434_4127">
        <path fill="#fff" d="M0 0h36v32H0z" />
      </clipPath>
      <clipPath id="clip1_1434_4127">
        <path fill="#fff" d="M0 0h35.636v32H0z" />
      </clipPath>
    </defs>
  </svg>
))
SvgAppLogoShort.displayName = 'SvgAppLogoShort'
const Memo = memo(SvgAppLogoShort)
export { Memo as SvgAppLogoShort }
